<template>
  <div
    :class="`mb-5 shadow-${creating ? 'lg' : 'md'} border border-gray-200 divide-y > * rounded-md`"
  >
    <div class="w-full mx-auto bg-gray-100 text-xl text-purple-500 font-bold p-3 rounded">
      <div v-if="creating">
        <label
          for="name"
        >
          Nombre de la regla
        </label>
        <input
          v-if="creating"
          ref="categoryInput"
          v-model="name"
          name="name"
          type="text"
          class="rounded-md w-full text-xl px-2 border-2 text-gray-500 border-purple-500 border-opacity-25 focus:border-opacity-100 mt-1"
        >
      </div>
      <div
        v-else
        class="flex justify-between items-center"
      >
        <div>
          {{ rule.name }}
        </div>
        <a @click="deleteRule">
          <eva-icon
            class="opacity-50 hover:opacity-100"
            name="trash-outline"
            fill="#FF7570"
          />
        </a>
      </div>
    </div>
    <div class="flex flex-wrap text-lg leading-10 p-4">
      <div class="m-1">
        Las personas que pertenecen a
      </div>
      <div class="text-lg m-1">
        <select
          :class="`bg-white text-center border-b-2 appearance-none ${selectedTag ? 'text-purple-500 border-purple-500' : 'text-gray-400 border-gray-400'} hover:border-gray-500 cursor-pointer`"
          :value="selectedTag"
          @input="selectedTag = $event.target.value"
        >
          <option
            class="hidden"
            :value="null"
            disabled
            selected
          >
            etiqueta
          </option>
          <option
            v-for="(tag, key) in instancesInfo[instanceID].tags"
            :key="tag"
            class="text-purple-500 px-1"
            :value="key"
          >
            {{ tag }}
          </option>
        </select>
      </div>
      <div class="m-1">
        <span class="font-bold text-purple-500">NO</span> pueden entrar los
      </div>
      <div
        class="px-2 m-1"
      >
        <tag-manager
          :disabled="false"
          :success="false"
          :selectableTags="days"
          :currentTags="currentDays"
          :rules="{ regex: /^[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF\-' ]*$/ }"
          placeholder="días"
          @tag:add="addDay"
          @tag:remove="removeDay"
          @state:search="isSearching = $event"
        />
      </div>
    </div>
    <div
      v-if="creating"
      class="sm:flex justify-end p-4"
    >
      <a
        class="sm:w-64 cursor-pointer text-gray flex px-4 py-2 rounded-md items-center text-md mt-4"
        @click="resetForm"
      >
        <div
          class="block-inline text-center w-full"
        >
          Cancelar
        </div>
      </a>
      <button
        type="submit"
        class="disabled:opacity-25 disabled:pointer-events-none bg-green-400 sm:w-64 text-white flex px-4 py-2 rounded-md items-center text-md mt-4"
        @click="save"
      >
        <eva-icon
          name="save-outline"
          fill="#FFFFFF"
        />
        <div
          class="block-inline text-center w-full"
        >
          Guardar
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import tagManager from '../components/tagManager'
import { apiURL } from '../utils/firebase'
import { mapState, mapGetters } from 'vuex'
export default {
  components: {
    tagManager,
  },
  props: {
    rule: { type: Object, default: () => {} },
    creating: { type: Boolean, default: false },
  },
  data () {
    return {
      name: '',
      initializing: false,
      days: {
        0: 'Lunes',
        1: 'Martes',
        2: 'Miércoles',
        3: 'Jueves',
        4: 'Viernes',
        5: 'Sábado',
        6: 'Domingo',
      },
      selectedTag: null,
      currentDays: {},
    }
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      instanceID: state => state.admin.instanceID,
      persons: state => state.admin.persons,
      instancesInfo: state => state.auth.instancesInfo,
    }),
    ...mapGetters({
      tags: 'admin/tags',
    }),
  },
  watch: {
    selectedTag () {
      if (!this.creating && !this.initializing) {
        console.info('updating because of tags')
        this.updateRule()
      }
    },
    currentDays () {
      if (!this.creating && !this.initializing) {
        console.info('updating because of days')
        this.updateRule()
      }
    },
  },
  mounted () {
    if (!this.creating && Object.keys(this.rule).length) {
      this.initializing = true
      this.selectedTag = this.rule.tagID
      for (const numDay of Object.keys(this.rule.days)) {
        this.$set(this.currentDays, numDay, this.days[numDay])
      }
      this.$nextTick(() => {
        this.initializing = false
      })
    }
  },
  methods: {
    updateRule () {
      this.$f7.preloader.show('Eliminando regla...')
      const days = {}
      for (const day of Object.keys(this.currentDays)) {
        days[day] = true
      }
      this.$f7.request.postJSON(`${apiURL}/rules/update`,
        {
          userID: this.auth.uid,
          ruleID: this.rule.id,
          instanceID: this.instanceID,
          rule: {
            name: this.rule.name,
            days: days,
            tagID: this.selectedTag,
          },
        },
        response => {
          console.info(response)
          this.$f7.preloader.hide()
        },
        err => {
          console.error(err)
          this.$f7.preloader.hide()
        })
    },
    deleteRule () {
      this.$f7.dialog.confirm(`¿Estás seguro de que deseas eliminar la regla <span class="font-bold text-purple-500">${this.rule.name}</span>?`, '¿Seguro?', () => {
        this.$f7.preloader.show('Eliminando regla...')
        this.$f7.request.postJSON(`${apiURL}/rules/delete`,
          {
            userID: this.auth.uid,
            ruleID: this.rule.id,
            instanceID: this.instanceID,
          },
          response => {
            console.info(response)
            this.$f7.preloader.hide()
          },
          err => {
            console.error(err)
            this.$f7.preloader.hide()
          })
      })
    },
    save (e) {
      // TODO: validate inputs, at least not empty
      const days = {}
      for (const day of Object.keys(this.currentDays)) {
        days[day] = true
      }
      this.$f7.preloader.show('Creando regla...')
      console.info({
        userID: this.auth.uid,
        instanceID: this.instanceID,
        rule: {
          name: this.name,
          days: days,
          tagID: this.selectedTag,
        },
      })
      this.$f7.request.postJSON(`${apiURL}/rules/create`,
        {
          userID: this.auth.uid,
          instanceID: this.instanceID,
          rule: {
            name: this.name,
            days: days,
            tagID: this.selectedTag,
          },
        },
        response => {
          console.info(response)
          this.$f7.preloader.hide()
          this.resetForm()
        },
        err => {
          console.error(err)
          this.$f7.preloader.hide()
        })
      this.name = ''
      this.selectedTag = null
      this.currentDays = {}
    },
    resetForm () {
      this.name = ''
      this.selectedTag = null
      this.currentDays = {}
      this.$emit('close')
    },
    addDay (dayID) {
      if (dayID) {
        if (!this.currentDays[dayID]) {
          this.$set(this.currentDays, dayID, this.days[dayID])
        }
      }
    },
    removeDay (dayID) {
      this.$delete(this.currentDays, dayID)
    },
  },
}
</script>
